
<script>

    import { createEventDispatcher } from "svelte";


    const dispatch = createEventDispatcher();

    export let active;
    export let showBack;
    export let showDelete;

    $: isActive = (str) => active === str ? 'active' : '';


    const onBackClicked = () => {

        dispatch('back');
    };

    const onDeleteClicked = () => {

        dispatch('delete');
    };

</script>


{#if showBack}

    <div id="settings-back" on:click={() => onBackClicked()}>

        <span>Zurück</span>

    </div>

{/if}

<div id="settings-nav">

    <ul>

        <li class="{ isActive('locations') }">

            <a href="/settings/locations">

                <span>Locations</span>

            </a>

        </li>

        <li class="{ isActive('billing') }">

            <a href="/settings/billing">

                <span>Zahlung</span>

            </a>

        </li>

        <li class="{ isActive('profile') }">

            <a href="/settings/profile">

                <span>Profil</span>

            </a>

        </li>

    </ul>

</div>

{#if showDelete}

    <div id="settings-delete" on:click={() => onDeleteClicked()}>

        <span>Löschen</span>

    </div>

{/if}


<style>

    #settings-back,
    #settings-delete {
        position: absolute;
        display: flex;
        top: 4vh;
        padding: 0.83vh 2.5vh;
        border-radius: 1.01vh;
        cursor: pointer;
    }

    #settings-back {
        left: 4vh;
    }

    #settings-delete {
        right: 4vh;
    }

    #settings-nav {
        display: flex;
        flex-direction: row;
        padding-top: 4vh;
    }

    #settings-nav ul {
        display: flex;
        padding: 0;
        margin: 0;
    }

    #settings-nav li {
        display: flex;
        flex-direction: column;
        padding: 0.83vh 1.57vh;
        border-radius: 1.85vh;
        margin-right: 2.22vh;
    }

    #settings-nav li:last-child {
        margin-right: 0;
    }

    #settings-nav li.active,
    #settings-back {
        background-color: #FFFFFF;
        -webkit-box-shadow: 0px 5px 15px 0px rgba(73, 119, 172, 0.15);
        -moz-box-shadow: 0px 5px 15px 0px rgba(73, 119, 172, 0.15);
        box-shadow: 0px 5px 15px 0px rgba(73, 119, 172, 0.15);
    }

    #settings-delete {
        background-color: #E83A91;
        -webkit-box-shadow: 0px 5px 15px 0px rgba(73, 119, 172, 0.15);
        -moz-box-shadow: 0px 5px 15px 0px rgba(73, 119, 172, 0.15);
        box-shadow: 0px 5px 15px 0px rgba(73, 119, 172, 0.15);
    }

    #settings-nav li a,
    #settings-back span {
        color: #383874;
        font-family: 'Raleway', sans-serif;
        font-weight: 400;
        font-size: 1.75vh;
    }

    #settings-delete span {
        color: #FFFFFF;
        font-family: 'Raleway', sans-serif;
        font-weight: 400;
        font-size: 1.75vh;
    }

    #settings-nav li.active a {
        font-weight: 500;
    }

</style>
